export default {
  "viewDocument": "Afficher",
  "unableToLoadBudgets": "Incapable de charger des budgets.",
  "budgetUpdated": "Budget mis à jour",
  "theBudgetDetailsHaveBeenSaved": "Les détails budgétaires ont été sauvegardés.",
  "unableToUpdateBudget": "Impossible de mettre à jour le budget",
  "pleaseTryAgainInAMoment": "Veuillez réessayer dans un instant.",
  "budgetDeleted": "Budget supprimé",
  "theBudgetHasBeenRemoved": "Le budget a été supprimé.",
  "budgetCannotBeDeleted": "Le budget ne peut être supprimé.",
  "unableToDeleteBudget": "Impossible de supprimer le budget",
  "onlyDraftBudgetsWithoutLockedVersionsCanBeDeleted": "Seuls les projets de budget sans versions verrouillées peuvent être supprimés.",
  "unableToCreateBudget": "Impossible de créer un budget.",
  "newBudget": "Nouveau budget",
  "createANewBudget": "Créer un nouveau budget",
  "name": "Nom",
  "fy2025OperatingBudget": "Exercice budgétaire 2025",
  "fiscalYearStart": "Année financière début",
  "fiscalYearEnd": "Exercice budgétaire fin",
  "copyFromBudgetOptional": "Copie du budget (facultatif)",
  "selectBudget": "Sélectionnez le budget",
  "noCopy": "Pas de copie",
  "copyFromVersionOptional": "Copie de la version (facultatif)",
  "selectVersion": "Sélectionnez la version",
  "currentVersion": "Version actuelle",
  "cancel": "Annuler",
  "createBudget": "Créer un budget",
  "budgetingError": "Erreur budgétaire",
  "loadingBudgets": "Chargement des budgets...",
  "editBudget": "Modifier le budget",
  "saveChanges": "Enregistrer les modifications",
  "deleteBudget": "Supprimer le budget",
  "delete": "Supprimer",
  "noBudgetsYetClickNewBudgetToCreateYourFirstBudget": "Pas encore de budget. Cliquez sur « Nouveau budget » pour créer votre premier budget.",
  "fiscalYear": "Année financière",
  "status": "Statut",
  "updated": "Mis à jour",
  "open": "Ouvrir",
  "openBudgetActions": "Actions budgétaires ouvertes",
  "edit": "Modifier",
  "jan": "Jan",
  "feb": "Fébril",
  "mar": "Mar",
  "apr": "Avr",
  "may": "Mai",
  "jun": "Juno.",
  "jul": "Jul",
  "aug": "Aug",
  "sep": "Sep",
  "oct": "Oct oct.",
  "nov": "Nov",
  "dec": "Déc.",
  "q1": "Q1",
  "q2": "Q2",
  "q3": "Q3",
  "q4": "Q4",
  "draft": "Brouillon",
  "submitted": "Soumis",
  "boardApproved": "Conseil approuvé",
  "locked": "Verrouillés",
  "rejected": "Rejetée",
  "originalBudget": "Budget initial",
  "reforecast": "Réviser les prévisions",
  "boardMandated": "Conseil chargé",
  "other": "Autre",
  "operating": "Fonctionnement",
  "capex": "CapEx",
  "fyDatesNotSet": "Dates d ' admission non réglées",
  "allDepartments": "Tous les départements",
  "selectGlAccount": "Sélectionnez le compte GL",
  "searchGlAccounts": "Rechercher des comptes GL...",
  "noGlAccountsFound": "Aucun compte GL n'a trouvé.",
  "selectDepartment": "Sélectionnez le département",
  "searchDepartments": "Les départements de recherche...",
  "noDepartmentsFound": "Aucun ministère n'a été trouvé.",
  "unableToLoadBudgetDetails": "Impossible de charger les détails du budget.",
  "unableToLoadReferenceData": "Impossible de charger les données de référence.",
  "unableToLoadBudgetLines": "Incapable de charger des lignes budgétaires.",
  "couldntLoadYourAutosavePreference": "Je ne pourrais pas charger votre préférence auto-save",
  "autosaveIsOffByDefaultUntilWeCanLoadYourSetting": "Auto-save est désactivé par défaut jusqu'à ce que nous puissions charger votre réglage.",
  "allCategories": "Toutes les catégories",
  "lineAlreadyExists": "La ligne existe déjà",
  "aBudgetLineWithTheseDetailsAlreadyExists": "Une ligne budgétaire avec ces détails existe déjà.",
  "unableToPrepareAttachments": "Incapable de préparer des pièces jointes",
  "pleaseTryAgain": "Veuillez réessayer.",
  "lineDetailsChanged": "Les détails de ligne ont changé",
  "attachmentsWereClearedPleaseReuploadAnyDocuments": "Les pièces jointes ont été effacées. Veuillez recharger tout document.",
  "unableToDiscardDraftLine": "Incapable de rejeter le projet de ligne",
  "autosaved": "Enregistré automatiquement",
  "changesSavedAutomatically": "Changements enregistrés automatiquement.",
  "budgetSaved": "Budget économisé",
  "changesHaveBeenSaved": "Des changements ont été enregistrés.",
  "unableToSaveBudgetLines": "Incapable d'économiser des lignes budgétaires.",
  "autosaveFailed": "Auto-save échoué",
  "autosaveFailedPleaseClickSaveChanges": "Auto-save échoué, s'il vous plaît cliquez sur Enregistrer des changements.",
  "readonlyVersion": "Version en lecture seule",
  "readonlyVersionCantBeAutosaved": "La version en lecture seule ne peut pas être sauvegardée automatiquement.",
  "unableToUpdateAutosave": "Impossible de mettre à jour auto-save",
  "unableToDeleteLine": "Impossible de supprimer la ligne.",
  "newVersionCreated": "Nouvelle version créée",
  "aNewDraftVersionIsReadyForEditing": "Une nouvelle version est prête pour l'édition.",
  "unableToCreateNewVersion": "Incapable de créer une nouvelle version.",
  "versionDetailsUpdated": "Versions mises à jour",
  "versionMetadataSavedSuccessfully": "Les métadonnées de version sauvegardées avec succès.",
  "unableToUpdateVersion": "Impossible de mettre à jour la version",
  "pleaseTryAgainOrRefreshThePage": "Veuillez réessayer ou rafraîchir la page.",
  "unableToUpdateCurrentVersion": "Impossible de mettre à jour la version actuelle.",
  "submittedToTheGmForReleaseVotingWillOpenOnceApproved": "Soumis au Mécanisme mondial pour sa libération — le vote s ' ouvrira une fois approuvé.",
  "votingAlreadyOpen": "Vote déjà ouvert",
  "votingIsAlreadyOpenForThisBudgetRefreshingTheMotionStatus": "Le vote est déjà ouvert pour ce budget. Renouvellement du statut de la motion.",
  "alreadySubmitted": "Déjà présenté",
  "thisBudgetIsAlreadyQueuedForGmRelease": "Ce budget est déjà prévu pour la libération du MM.",
  "votingAlreadyClosed": "Votent déjà clos",
  "thisBudgetMotionHasAlreadyBeenClosed": "Cette motion budgétaire a déjà été close.",
  "submissionFailed": "Soumission échouée",
  "unableToSubmitThisBudgetForBoardApproval": "Incapable de soumettre ce budget pour approbation par le conseil.",
  "withdrawSubmissionThisWillRevertToDraftAndRemoveItFromTheBoardQueue": "Retrait de la soumission? Cela va revenir à la rédaction et le retirer de la file d'attente.",
  "submissionWithdrawnBudgetIsBackInDraft": "Soumission retirée — le budget est de retour dans le projet.",
  "thisSubmissionCanOnlyBeWithdrawnBeforeVotingOpens": "Cette demande ne peut être retirée qu ' avant l ' ouverture du vote.",
  "votesAlreadyExistForThisMotion": "Les votes existent déjà pour cette motion.",
  "thisBudgetVersionIsNotCurrentlySubmitted": "Cette version budgétaire n ' est pas actuellement présentée.",
  "noPendingMotionWasFoundForThisSubmission": "Aucune motion en suspens n ' a été trouvée pour cette présentation.",
  "unableToWithdrawSubmission": "Incapable de retirer la demande",
  "unableToDeleteBudgetEnsureItIsInDraftAndNoVersionsAreLocked": "Impossible de supprimer le budget. Assurez-vous qu'il est en projet et aucune version n'est verrouillée.",
  "statusUpdated": "État actualisé",
  "unableToUpdateStatus": "Incapable de mettre à jour le statut",
  "thisReopensAnApprovedBudgetAndAllowsEditsContinue": "Cela réouvre un budget approuvé et permet des modifications. Continuer?",
  "lockedBudgetsCannotBeEditedAgainContinue": "Les budgets verrouillés ne peuvent plus être modifiés. Continuer?",
  "loadingBudgetDetails": "Charger les détails du budget...",
  "backToBudgeting": "Retour à la budgétisation",
  "budgetNotFound": "Budget non trouvé",
  "theSelectedBudgetCouldNotBeFoundForThisClub": "Le budget sélectionné n'a pas été trouvé pour ce club.",
  "backToBudgets": "Retour aux budgets",
  "newVersion": "Nouvelle version",
  "createANewVersion": "Créer une nouvelle version",
  "createFromCurrentVersion": "Créer à partir de la version actuelle?",
  "copyFromSelectedVersion": "Copie de la version sélectionnée",
  "blankVersionNoLines": "Version en blanc (pas de lignes)",
  "label": "Étiquette",
  "purpose": "But",
  "notes": "Notes",
  "optionalNotesForThisVersion": "Notes facultatives pour cette version",
  "createVersion": "Créer une version",
  "setAsCurrent": "Définissez comme Current",
  "viewInBoardPortal": "Vue sur le portail de bord",
  "submitForBoardApproval": "Soumettre l'approbation de la Commission",
  "withdrawSubmission": "Demande de retrait",
  "budgetSettings": "Paramètres budgétaires",
  "disableAutosave": "Désactiver Auto-Save",
  "activateAutosave": "Activer Auto-Save",
  "confirmStatusChange": "Confirmer le changement de statut",
  "confirm": "Confirmer",
  "department": "Département",
  "category": "Catégorie",
  "searchGl": "Recherche GL",
  "searchByGlAccount": "Recherche par compte GL",
  "view": "Afficher",
  "monthly": "mensuel",
  "quarterly": "Trimestre",
  "quarterlyViewEnabledForSmallerScreens": "Vue trimestrielle activée pour les écrans plus petits.",
  "addLine": "Ajouter la ligne",
  "editBudgetLine": "Modifier la ligne budgétaire",
  "addBudgetLine": "Ajouter la ligne budgétaire",
  "glAccount": "Compte du grand livre",
  "ownerOptional": "Propriétaire (facultatif)",
  "searchStaffByNameOrEmail": "Rechercher le personnel par nom ou email",
  "unassigned": "Non attribué",
  "noMatches": "Pas de correspondance",
  "typeAtLeast2CharactersToSearch": "Saisissez au moins 2 caractères pour rechercher.",
  "searchingStaff": "Le personnel de recherche...",
  "selectAStaffMemberToAssignOwnership": "Sélectionnez un fonctionnaire pour attribuer la propriété.",
  "uploadSupportingDocumentsForThisBudgetLine": "Charger les documents justificatifs pour cette ligne budgétaire.",
  "deleteThisBudgetLine": "Supprimer cette ligne budgétaire ?",
  "thisWillRemoveTheLineFromTheVersionYouCanReaddItLaterIfNeeded": "Cela supprimera la ligne de la version. Vous pouvez la ré-ajouter plus tard si nécessaire.",
  "versionDetails": "Version détaillée",
  "created": "Créé",
  "saveDetails": "Plus de détails",
  "saving": "Enregistrement…",
  "thisVersionIsNotInDraftAndCannotBeEditedCreateANewVersionToContinueEditing": "Cette version n'est pas en version préliminaire et ne peut pas être modifiée. Créez une nouvelle version pour continuer l'édition.",
  "somethingWentWrong": "Quelque chose ne va pas.",
  "total": "Total",
  "noBudgetLinesYetUseAddLineToStartBuildingYourBudget": "Pas encore de lignes budgétaires. Utilisez \"Add Line\" pour commencer à construire votre budget.",
  "lineActions": "Actions en ligne",
  "editLine": "Modifier la ligne",
  "documents": "Documents…",
  "deleteLine": "Supprimer la ligne",
  "supportingDocuments": "Documents d ' appui",
  "selectAGlAccountAndDepartmentToEnableDocumentUploads": "Sélectionnez un compte GL et un département pour activer les téléchargements de documents.",
  "unableToLoadDocuments": "Incapable de charger des documents",
  "uploadFailed": "Chargement échouée",
  "deleteFailed": "Supprimer échoué",
  "downloadFailed": "Télécharger échoué",
  "previewFailed": "Aperçu échoué",
  "dragDropFilesHere": "Faites glisser des fichiers ici",
  "pdfImagesWordDocsMax25mbEach": "PDF , images, docs Word • max 25MB chacun",
  "hangTightWhileWePrepUploads": "Accrochez-vous pendant que nous préparons les téléchargements.",
  "browseFiles": "Parcourir les fichiers",
  "loadingDocuments": "Chargement des documents...",
  "refresh": "Actualiser",
  "download": "Télécharger",
  "uploading": "Téléchargement",
  "failed": "Échec",
  "complete": "Complet",
  "noDocumentsAttachedYet": "Aucun document n'est encore joint.",
  "documentPreview": "Aperçu du document",
  "previewNotAvailableDownloadToViewThisFile": "Aperçu non disponible — téléchargement pour voir ce fichier.",
  "budgetLineDocuments": "Documents budgétaires",
  "attachSupportingDocumentsForThisBudgetLine": "Joindre des documents justificatifs pour cette ligne budgétaire.",
  "openNamed": "Ouvrir {name}",
  "deleteNamed": "Supprimer “ {name} ”? Cela ne peut pas être déconcerté.",
  "valuesCurrency": "Toutes les valeurs en {currency} ( {symbol} )",
  "updatedAt": "Mise à jour {date}",
  "createdAt": "Créé {date}",
  "versionNumber": "Version v {number}",
  "reforecastVersion": "Reforecast (v {number} )",
  "statusSet": "État budgétaire fixé à {status} .",
  "ownerName": "Propriétaire: {name}",
  "departmentDefault": " (dépt par défaut)",
  "autoSaveState": "Auto-save: {state}",
  "on": "On y va.",
  "off": "Officier",
  "submitting": "Soumettre...",
  "withdrawing": "Retrait...",
  "searching": "Recherche…",
  "documentCountOne": "Documents : {count}",
  "documentCountMany": "Documents : {count}",
  "uploadedAt": "Téléchargé {date}",
  "noResults": "Aucune ligne budgétaire ne correspond à vos filtres.",
  "pending_open": "Soumis (En attente de l ' Open du Mécanisme mondial)",
  "votingOpen": "Vote ouvert",
  "votingClosed": "Votings closed",
  "withdrawn": "Retiré",
  "close": "Fermer",
  "errors": {
    "permissionDenied": "Vous n'avez pas la permission d'effectuer cette action. Contactez votre administrateur de club.",
    "invalidFields": "Vérifiez le nom, les dates fiscales et le budget/version sélectionné, puis essayez à nouveau.",
    "budgetMissing": "Ce budget n'est plus disponible. Retour à la liste budgétaire.",
    "versionMissing": "Cette version n'est plus disponible. Rafraîchissez et sélectionnez une autre version.",
    "lineMissing": "Cette ligne n'est plus disponible. Rafraîchissez le budget.",
    "versionReadOnly": "Cette version est en lecture seule. Créez un nouveau projet de version pour apporter des changements.",
    "invalidTransition": "Ce changement de statut n'est pas autorisé. Rafraîchissez pour vérifier l'état actuel.",
    "deleteRestricted": "Seuls les projets de budget sans versions verrouillées peuvent être supprimés.",
    "duplicateLine": "Une ligne budgétaire avec ces détails existe déjà. Modifier la ligne existante.",
    "fileTooLarge": "Choisissez un fichier ne dépassant pas 25 Mo.",
    "fileType": "Choisissez un document supporté PDF , image ou Word.",
    "fileSizeMismatch": "La taille du fichier téléchargé ne correspond pas. Essayez de télécharger le fichier à nouveau.",
    "attachmentMissing": "Ce document n'est plus disponible.",
    "withdrawRestricted": "Cette demande ne peut être retirée qu ' avant l ' ouverture du vote.",
    "votesExist": "Les votes existent déjà pour cette motion.",
    "notSubmitted": "Cette version budgétaire n ' est pas actuellement présentée.",
    "motionMissing": "Aucune motion en suspens n ' a été trouvée pour cette présentation."
  },
  "deleteBudgetConfirm": "Supprimer le budget ?"
};
